import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class SubsidiaryDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      multiple,
      preload = true,
      excluded_subsidiaries,
      default_subsidiary = null,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='subsidiary'
          type='subsidiary'
          preload={preload}
          searchParams={{
            excluded_subsidiaries
          }}
          valueField='id'
          defaultValue={ default_subsidiary }
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
        />
      </div>
    );
  }
}


function mapStateToProps(state) {
  const default_subsidiary = state && state.subsidiary && state.subsidiary.primary_subsidiary &&
    state.subsidiary.primary_subsidiary._id;
  
    return {
    default_subsidiary
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SubsidiaryDropdown);

